// These are all exact routes, so be sure to keep that in mind when adding any new items.
export const assetUIRoutes = [
   '/contacts/groups'
]